(() => {
  // source/product-description.js
  customElements.define("product-description-component", class ProductDescription extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", event => {
        var _event$target$closest, _event$target;
        const heading = (_event$target$closest = (_event$target = event.target).closest) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.call(_event$target, ".tab-content--heading");
        if (heading && this.toggleTab(heading)) event.preventDefault();
      });
    }
    toggleTab(heading) {
      var _heading$getAttribute;
      if (!(heading !== null && heading !== void 0 && heading.matches(".tab-content--heading")) || heading.closest("product-description-component") !== this) return false;
      const panelId = heading.getAttribute("aria-controls") || ((_heading$getAttribute = heading.getAttribute("aria-control")) === null || _heading$getAttribute === void 0 ? void 0 : _heading$getAttribute.replace(/^#/, ""));
      const panels = Array.from(this.querySelectorAll(".tab-content--body[id]")).filter(panel => panel.closest("product-description-component") === this);
      const selectedPanel = panelId && panels.find(panel => panel.id === panelId);
      if (!selectedPanel) return false;
      this.querySelectorAll(".tab-content--heading").forEach(item => {
        if (item.closest("product-description-component") === this) {
          item.classList.toggle("active", item === heading);
        }
      });
      panels.forEach(panel => panel.classList.toggle("active", panel === selectedPanel));
      return true;
    }
  });
})();
